export class ServerRequest {
  constructor ({ requestType = '', userId = 0, fileType = '', fileTimestamp = 0, fileName = '' } = {}) {
    this.requestType = requestType
    this.userId = userId
    this.fileType = fileType
    this.fileTimestamp = new Date(fileTimestamp)
    this.fileName = fileName
  }

  backendModel () {
    return {
      requestType: this.requestType,
      userId: this.userId,
      fileType: this.fileType,
      fileTimestamp: this.fileTimestamp.getTime(),
      fileName: this.fileName
    }
  }
}
